// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header_wrapper-2PFDf";
var _4 = "header-3Yx82";
var _5 = "title-3DGZT";
export { _1 as "__esModule", _2 as "mobile", _3 as "header_wrapper", _4 as "header", _5 as "title" }
export default { "__esModule": _1, "mobile": _2, "header_wrapper": _3, "header": _4, "title": _5 }
